import { useEffect } from 'react'
import {
  addAddressError,
  removeAddressError,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectActiveAddress } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { useDispatch, useSelector } from 'react-redux'
import useGasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeter'

const useGasMeterListener = () => {
  const dispatch = useDispatch()
  const activeAddress = useSelector(selectActiveAddress)
  const { pceNo, treatMeterDataInformation, gasMeterUpdate } = useGasMeter({ type: 'client' })

  // The meter id error lives on the active address in v2 (same store slot the
  // MeterInput field reads through selectCurrentAddressErrors), so the GRDF
  // websocket callback writes there instead of the removed v1 common errors.
  const setMeterIdError = message => {
    dispatch(addAddressError({ data: { meter_id_gas: [message] }, id: activeAddress }))
  }

  const clearMeterIdError = () => {
    dispatch(removeAddressError({ id: activeAddress, key: 'meter_id_gas' }))
  }

  useEffect(() => {
    if (!pceNo) {
      return
    }
    window.Echo.channel(`pce.${pceNo}`).listen('.pce.response', e => {
      if (e.status === 'pending') {
        gasMeterUpdate({
          pceEligibilityPending: true,
        })
      }

      if (e.status === 'error') {
        gasMeterUpdate({
          pceEligibilityPending: false,
          pceEligibilityLoading: false,
        })
        setMeterIdError(e.response.exception)
      }

      if (e.response.gas?.deliveryPoint?.pointOfDelivery && e.response.gas.deliveryPoint.pointOfDelivery !== pceNo) {
        return
      }

      if (e.status === 'success') {
        gasMeterUpdate({
          pceEligibilityPending: false,
          pceEligibilityLoading: false,
        })
        clearMeterIdError()
        const pceInformation = e.response

        if (pceInformation.exception) {
          setMeterIdError(pceInformation.exception)
          return
        }
        if (pceInformation.error && !Array.isArray(pceInformation.error)) {
          if (
            typeof pceInformation.error.errors?.authorizations !== 'undefined' &&
            Array.isArray(pceInformation.error.errors.authorizations)
          ) {
            setMeterIdError(pceInformation.error.errors.authorizations[0])
            return
          }
          const pceErrorMsg =
            typeof pceInformation.error === 'string' ? pceInformation.error : pceInformation.error?.message ?? 'Erreur PCE'
          setMeterIdError(pceErrorMsg)
          return
        }
        treatMeterDataInformation(pceInformation)
      }
    })
    return () => {
      window.Echo.leaveChannel(`pce.${pceNo}`)
    }
  }, [pceNo])
}

export default useGasMeterListener
